import { TipoVeiculoAPI } from "@/api/tipo_veiculo.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { TipoVeiculo } from "@/models/tipo_veiculo";

const tipoVeiculoApi = new TipoVeiculoAPI();

const getAll = (): AxiosObservable<TipoVeiculo[]> => {
  return tipoVeiculoApi.getAll();
};

export default { getAll };
